import { render, staticRenderFns } from "./ace.vue?vue&type=template&id=c153e686&scoped=true&"
import script from "./ace.vue?vue&type=script&lang=js&"
export * from "./ace.vue?vue&type=script&lang=js&"
import style0 from "./ace.vue?vue&type=style&index=0&id=c153e686&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c153e686",
  null
  
)

component.options.__file = "ace.vue"
export default component.exports